import { render, staticRenderFns } from "./WidgetBarChart.vue?vue&type=template&id=d6767450&"
import script from "./WidgetBarChart.vue?vue&type=script&lang=js&"
export * from "./WidgetBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports